<template>
  <div class="lib__field">
    <h2>Formulaires en production</h2>
    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'complaint')" class="lib__tile" data-cy="hp-form-tile-complaint">
        <div class="lib__tile__text" data-cy="complaint-form">{{ $t('complaint.complaint') }}</div>
      </router-link>
      <router-link :to="getUrl(lang, 'prc')" class="lib__tile">
        <div class="lib__tile__text" data-cy="prc-form">{{ $t('prc.formTitle') }}</div>
      </router-link>
    </div>
    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'eanrequest')" class="lib__tile" data-cy="hp-form-tile-eanrequest">
        <div class="lib__tile__text" data-cy="eanrequest-form">{{ $t('eanRequest.formTitle') }}</div>
      </router-link>
      <router-link :to="getUrl(lang, 'regularisation')" class="lib__tile" data-cy="hp-form-tile-regularisation">
        <div class="lib__tile__text" data-cy="regularisation-form">{{ $t('regularisation.formTitle') }}</div>
      </router-link>
    </div>

    <br>
    <h2>Formulaires en cours de migration</h2>
    <div class="lib__tiles">
      <router-link :to="getUrl(lang, 'protected-customer-request')" class="lib__tile">
        <div class="lib__tile__text" data-cy="protected-customer-request-form">{{ $t('protectedCustomerRequest.formTitle') }}</div>
      </router-link>
    </div>

      <br>
      <h2>Formulaires migrés / obsolètes</h2>
    <div>-</div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { routes } from '@/router'
import moment from 'moment'
import { localize } from 'vee-validate'

@Component({
  name: 'home',
})
export default class Home extends Vue {
  //#region [Data]
  @Prop({ type: String, required: true }) public readonly lang!: string
  //#endregion

  //#region [Watch]
  @Watch('lang')
  public onLangChanged(value: string) {
    this.$i18n.locale = value
    localize(value)
    this.$store.commit('SET_LANGUAGE', value)
    moment.locale(value)
  }
  //#endregion

  //#region [Method]
  public getUrl(lang: string, form: string): string {
    return routes.find((r) => r.name === form)!.paths[lang]
  }
  //#endregion
}
</script>
